<template>
  <ProductPageLayout
    name="VideoCvt"
    :logo="logo"
    :hero-image="heroImage"
    lead="Convert mainstream video and audio formats with merge, split, watermark, and compress tools for creators and everyday office work."
    :feature-lines="featureLines"
    download-link="/ftp/packages/videocvt/VideoCvtSetup.exe"
    download-file-name="VideoCvtSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="Convert, merge, split, and watermark for creation and office transcoding."
    other-desc="More media tools for everyday video and audio tasks."
    reviews-desc="Real feedback that keeps improving VideoCvt."
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'VideoConverter',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/videocvt/videovc_48x48.png'),
      heroImage: require('@/assets/videocvt/mainpage.png'),
      featureLines: [
        'Video convert / merge / split / watermark',
        'Audio convert / compress / video to GIF / enhance'
      ],
      metaItems: [
        { icon: 'video', label: 'Many formats' },
        { icon: 'fast', label: 'Batch jobs' },
        { icon: 'sparkle', label: 'HD output' }
      ],
      detailedFeatures: [
        {
          title: 'Video convert',
          brief: 'One-click convert between mainstream video formats with stable output.',
          detail: 'Supports MP4, MOV, AVI, MKV, FLV and more. Batch import runs continuously — ideal for frequent transcoding.',
          image: require('@/assets/videocvt/feature_convert.png')
        },
        {
          title: 'Video merge',
          brief: 'Stitch multiple clips into one finished file.',
          detail: 'Merge segments in order with unified resolution and encoding — less repetitive work in a second editor.',
          image: require('@/assets/videocvt/feature_split.png')
        },
        {
          title: 'Watermark',
          brief: 'Text or image watermarks to protect your content.',
          detail: 'Customize position, opacity, and size for teaching, brand, and social distribution.',
          image: require('@/assets/videocvt/视频水印.png')
        },
        {
          title: 'Video split',
          brief: 'Cut long videos into flexible clips.',
          detail: 'Split by time range to extract highlights or chapter segments for publish and archive.',
          image: require('@/assets/videocvt/feature_split.png')
        }
      ],
      otherFeatures: [
        { title: 'Video compress', description: 'Shrink size while keeping clarity for upload and storage.', iconImage: require('@/assets/videocvt/video_compress.png') },
        { title: 'Video to GIF', description: 'Turn clips into motion assets for social posts and product demos.', iconImage: require('@/assets/videocvt/video_2gif.png') },
        { title: 'Enhance', description: 'Adjust brightness, contrast, and saturation for a quick visual polish.', iconImage: require('@/assets/videocvt/video_beauty.png') },
        { title: 'Audio convert', description: 'Extract and convert audio formats for editing, archive, and sharing.', iconImage: require('@/assets/videocvt/audio_convert.png') }
      ],
      reviews: [
        { name: 'Chris', comment: 'Fast and stable batch jobs — saves hours on course video exports.', avatar: require('@/assets/videocvt/avatar1.jpg') },
        { name: 'Pat', comment: 'Clear UI, focused tools. Audio extract and compress are daily drivers for me.', avatar: require('@/assets/videocvt/avatar2.jpg') },
        { name: 'Jamie', comment: 'School edits export to different formats easily; quality stayed better than I expected.', avatar: require('@/assets/videocvt/avatar3.jpg') },
        { name: 'Morgan', comment: 'Classroom capture convert and split are short paths — beginners get it quickly.', avatar: require('@/assets/videocvt/avatar4.jpeg') },
        { name: 'Drew', comment: 'Enough knobs for demos, reliable output for our team assets.', avatar: require('@/assets/videocvt/avatar5.jpeg') },
        { name: 'Quinn', comment: 'Video to GIF plus enhance is efficient for social creatives.', avatar: require('@/assets/videocvt/avatar6.jpeg') }
      ]
    }
  }
}
</script>
